import React from "react";
import Header from "./Header";

function Contact() {
  return (
    <div>
      <Header />
    </div>
  );
}

export default Contact;
